import { TabItemListCombinedProps } from './types';

const usePresenter = (props: TabItemListCombinedProps): TabItemListCombinedProps => {
  return props;
};

export default usePresenter;
